// extracted by mini-css-extract-plugin
export default {"icon":"DraggableDoor_icon__Mi-Kd"};